import { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useOnboarding } from './useOnboarding';
import { getUserPreferences, upsertUserPreferences } from './civicbeatData';

/**
 * OnboardingSync - Syncs onboarding topics between local storage and Supabase
 *
 * This component handles bidirectional sync:
 * 1. When user logs in with local topics → sync to Supabase
 * 2. When user logs in without local topics → load from Supabase
 */
export function OnboardingSync() {
  const { user } = useAuth();
  const { selectedTopics, setSelectedTopics } = useOnboarding();

  useEffect(() => {
    if (!user) return;

    const syncTopics = async () => {
      try {
        const prefs = await getUserPreferences(user.id);

        if (selectedTopics.length > 0 && (!prefs || prefs.topics.length === 0)) {
          await upsertUserPreferences(user.id, selectedTopics);
          console.log('[OnboardingSync] Synced local topics to Supabase:', selectedTopics);
        } else if (prefs && prefs.topics.length > 0 && selectedTopics.length === 0) {
          setSelectedTopics(prefs.topics);
          console.log('[OnboardingSync] Loaded topics from Supabase:', prefs.topics);
        } else if (selectedTopics.length > 0 && prefs && prefs.topics.length > 0) {
          const localTopicsStr = JSON.stringify([...selectedTopics].sort());
          const supabaseTopicsStr = JSON.stringify([...prefs.topics].sort());

          if (localTopicsStr !== supabaseTopicsStr) {
            await upsertUserPreferences(user.id, selectedTopics);
            console.log('[OnboardingSync] Updated Supabase with local topics:', selectedTopics);
          }
        }
      } catch (error) {
        console.error('[OnboardingSync] Error syncing topics:', error);
      }
    };

    syncTopics();
  }, [user, selectedTopics, setSelectedTopics]);

  return null;
}
